import React from 'react';

import {School} from '../../api/types/__generated__/data-contracts';
import {VStack} from '../../components/layout/layout.styled';
import {
    SchoolAcademicYearTableProvider
} from '../../components/academic-year-search-form/hooks';
import {AcademicYearSearchForm} from '../../components/academic-year-search-form';
import {AppHeading} from '../home/home-container.styles';
import {useSearchTable} from './hooks';

type SearchTableContainerProps = {
    onOpenChangeSchool: (school: School) => any
}

export const SearchTableContainer = ({onOpenChangeSchool}: SearchTableContainerProps) => {
    const tableProps = useSearchTable();

    return (
        <VStack spacing={'40px'} mb={'100px'}>
            <AppHeading data-testid={'AppHeading'}>
                Set School Academic Year
            </AppHeading>

            <SchoolAcademicYearTableProvider value={{onOpenChangeSchool}}>
                <AcademicYearSearchForm{...tableProps}/>
            </SchoolAcademicYearTableProvider>
        </VStack>
    );
};

